import { render, staticRenderFns } from "./TypeResource.vue?vue&type=template&id=280a4ba6&"
import script from "./TypeResource.vue?vue&type=script&lang=js&"
export * from "./TypeResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports